import { palette, typography } from "@src/core/styles";
import styled from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const HeaderForm = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SwitchContainer = styled.div`
  ${typography.body_large_regular};
  color: ${palette.colors.onsurface};
`;

export const WorkspaceName = styled.div`
  ${typography.body_medium_regular};
  color: ${palette.colors.secondary};
`;

export const TitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ContainerFlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  height: calc(100vh - 57px);
`;

export const QuestionWrapper = styled.div`
  & svg:hover {
    background-color: rgba(66, 73, 64, 0.08);
    border-radius: 50%;
  }
`;
